import React from 'react';
import { useIntl } from 'react-intl';

const DefaultChildren = () => {
  const intl = useIntl();

  return (
    <div className="flex justify-center">
      <button 
        type="submit" 
        className="inline-flex justify-center items-center min-w-[140px] h-9 my-4 px-[1.2rem] border-0 rounded-[3px] bg-[#393939] text-[0.9375rem] font-bold text-white transition-all hover:opacity-75 focus:outline-none"
      >
        {intl.formatMessage({ id: 'SAVE' })}
      </button>
    </div>
  );
};

export default DefaultChildren;
